import CacheInstallationState from './interfaces/CacheInstallationState';
import { setItem, getItem, removeItem } from 'owa-local-storage';
import getKeyName from './getKeyName';

const ERROR_COUNT_KEY: string = 'SWCacheErrorCount';

export function setConsecutiveErrorCount(
    windowObj: Window,
    state: CacheInstallationState,
    count: number
): void {
    let keyName = getKeyName(state.appName, ERROR_COUNT_KEY);
    if (count == 0) {
        removeItem(windowObj, keyName);
    } else {
        setItem(windowObj, keyName, '' + count);
    }
}

export function getConsecutiveErrorCount(windowObj: Window, state: CacheInstallationState): number {
    let errorCount = parseInt(getItem(windowObj, getKeyName(state.appName, ERROR_COUNT_KEY)));
    return isNaN(errorCount) ? 0 : errorCount;
}
